$(document).ready(function() {

  var flag=false;
$("#ConvertInchCm").click(function(e){
    e.stopPropagation();
    var val = $('table td span').text()
    if(flag && ($(this).text() == "Convert to CM"))
    {
         $("#value").text(val*2.54);
         $(this).text("Convert to Inches"); 
    }
    else
    {
        $("table td span").text(val/2.54);
        $(this).text("cm");
    }
       flag=!flag;
});

    $("a").each(function () {
        var linkHost = this.hostname;
        if (linkHost && linkHost !== location.hostname) {
            $(this).attr("target", "_blank").attr("rel", "noopener noreferrer");
        }
    });



  $('.readmore').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'block';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
event.preventDefault();
var descriptionFull = document.querySelector('.product-description-full');
descriptionFull.style.display = 'none';
var descriptionShort = document.querySelector('.product-description-short');
descriptionShort.style.display = 'block';window.scrollTo({top: 110, behavior: 'smooth'});
})
  
});


